export default __webpack_public_path__ + "static/media/feature_3.46a997fb.png";